import { Card } from 'antd';

/**
 * Renders a card. We generally use this as a page container. Passthru to Ant
 * Design.
 * https://ant.design/components/card/ for API
 */
const HVCard = props => {
    return <Card {...props} />;
};

export default HVCard;
